import { CHART_TYPE } from '@/entities/chart/model/constants';
import type { ChartTableType } from '@/entities/chart/model/types';

export const getTableType = (
  type: CHART_TYPE,
  historical: boolean,
): ChartTableType => {
  if (type === CHART_TYPE.CROSS_AXIS) return 'cross';
  if (historical) return 'cross';
  return 'single';
};
